import {applyMiddleware, compose, createStore as createReduxStore} from 'redux'
import {routerMiddleware} from 'react-router-redux'
import createBrowserHistory from 'history/createBrowserHistory'
import thunk from 'redux-thunk'
import rootReducer from './reducers'
import userManager from './containers/login/userManager'
import createOidcMiddleware from 'redux-oidc'


let history = null
export const createHistory = (options) => {
  if (history) return history

  history = createBrowserHistory(options)

  return history
}

let store = null

const createStore = (basename) => {
  if (store) return store

  const oidcMiddleware = createOidcMiddleware(userManager)

  const history = createHistory({basename})

  const initialState = {}
  const enhancers = []
  const middleware = [
    thunk,
    oidcMiddleware,
    routerMiddleware(history)
  ]

  if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension())
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  )

  store = createReduxStore(
    rootReducer,
    initialState,
    composedEnhancers
  )

  return store
}

export default createStore



// WEBPACK FOOTER //
// ./src/store.js